import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useLayoutEffect, useState, } from 'react';
import { CopyButtonView } from './CopyButtonView';
import useCopyClipboard from '../hooks/useCopyClipboard';
const useIsomorphicLayoutEffect = typeof document !== 'undefined' ? useLayoutEffect : useEffect;
const CopyButton = ({ className, toCopy, children, iconSize, iconClassName, disabled = false, portalContainerRef, }) => {
    const [isCopied, setCopied] = useCopyClipboard();
    const [isTooltipOpen, setTooltipOpen] = useState(false);
    const [container, setContainer] = useState(null);
    const handleCopyClick = () => {
        if (disabled)
            return;
        setCopied(toCopy);
        setTooltipOpen(true);
    };
    useIsomorphicLayoutEffect(() => {
        setContainer(portalContainerRef?.current ?? document.getElementById('widget'));
    }, [portalContainerRef]);
    return (_jsx(CopyButtonView, { className: className, iconSize: iconSize, iconClassName: iconClassName, disabled: disabled, isCopied: isCopied, isTooltipOpen: isTooltipOpen, setTooltipOpen: setTooltipOpen, container: container, handleCopyClick: handleCopyClick, children: children }));
};
export default CopyButton;
